var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.43431 11.4343C4.1219 11.7467 4.1219 12.2533 4.43431 12.5657L9.52548 17.6569C9.8379 17.9693 10.3444 17.9693 10.6569 17.6569C10.9693 17.3444 10.9693 16.8379 10.6569 16.5255L6.13137 12L10.6569 7.47452C10.9693 7.1621 10.9693 6.65557 10.6569 6.34315C10.3444 6.03073 9.8379 6.03073 9.52548 6.34315L4.43431 11.4343ZM19 12.8C19.4418 12.8 19.8 12.4418 19.8 12C19.8 11.5582 19.4418 11.2 19 11.2V12.8ZM5 12.8H19V11.2H5V12.8Z",
    fill: "#181818"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDown);
export default __webpack_public_path__ + "static/media/ic_Down.98189cb5e0460ab5e08a7fb8317dc280.svg";
export { ForwardRef as ReactComponent };